import {Button, Space, Typography} from "antd";
import {ExtendedSwitch} from "../../core/router/extended-switch/extended.switch";
import React, {useEffect} from "react";
import {ComponentPropsFromRoute} from "../../../routers/routers";
import {useTranslate} from "../../../hooks/translate.hook";
import {Link, useLocation} from "react-router-dom";
import {RouteButtons} from "../../common/route-tabs/route.buttons";
import {useNavigate} from "react-router";

export const AccountingMain: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {

    const t = useTranslate();
    const location = useLocation();
    const navigate  = useNavigate();

    useEffect(() => {
        if (location.pathname === "/accounting") {
            navigate("/accounting/daily-statements")
        }
    }, [location.pathname])

    return (
        <Space direction={"vertical"} size={[30, 30]}>
            <Typography.Title level={3} style={{margin: 0}}>
                {t("ACCOUNTING.MAIN.TITLE")}
            </Typography.Title>

            <RouteButtons routes={routeChildren!} />
        </Space>
    )
}